import { Routes, Route } from "react-router-dom";
import Home from "Pages/Home/Home";
import Login from "Pages/Login/Login";
import TrackingList from "Pages/Tracking/TrackingList";
import TrackingDetail from "Pages/Tracking/TrackingDetail";
import Announcements from "Pages/Announcements/Announcements";
import ChangePassword from "Pages/Account/ChangePassword";
import Contact from "Pages/Contact/Contact";
import InquiryForm from "Pages/Contact/InquiryForm";
import Profile from "Pages/Profile/Profile";
import PrivacyPolicy from "Pages/PrivacyPolicy/PrivacyPolicy";

import Header from "Layout/Header/Header";
import Footer from "Layout/Footer/Footer";

import { AuthProvider } from "./contexts/AuthContext";

// tet

const App = () => {
  return (
    <AuthProvider>
      <div className="App">
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/tracking" element={<TrackingList />} />
            <Route path="/tracking/:id" element={<TrackingDetail />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route
              path="/account/change-password"
              element={<ChangePassword />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact/inquiry" element={<InquiryForm />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route index element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
};

export default App;
